import React, { useRef, useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Content from "../../components/PageLayout/Content/Content";
import { hideDrawer, showDrawer } from "../../store/actions/ui";
import PageLayout from "../../components/PageLayout/PageLayout";
import { useNavigate } from "react-router-dom";
import Title from "../../components/Title/Title";
import Button from "../../components/Button/Button";
import { updateWholesalerbranch } from "../../store/actions/user";
import { useAppDispatch, useAppSelector } from "../../hooks";
import "./UpdateWholesaleForm.scss";
import { API_URL, appFetch } from "../../helpers/fetch";

function UpdateWholesaleForm() {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    control,
  } = useForm();
  const onSubmit = (data: any) => {
    const submitData = {
      wholesaler: {
        branch: {
          uuid: data?.branchName?.value,
        },
      },
    };
    dispatch(updateWholesalerbranch(submitData, navigate));
    dispatch(hideDrawer());
    //idk why need to window reload 
    setTimeout(() => {
      window.location.reload();
      
    }, 500);
  };
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [showBranchSelect, setShowBranchSelect] = useState(false);
  const [branchsList, setBranchsList] = useState([{ value: "", label: "" }]);
  const [wholesalerList, setWholesalerList] = useState([
    { value: "", label: "" },
  ]);

  const onClear = () => {
    if (selectInputRef.current) {
      selectInputRef.current.clearValue();
    } else {
      console.error("selectInputRef is null");
    }
  };
  useEffect(() => {
    fetchOptions();
  }, []);

  interface ApiData {
    uuid: string;
    ident: string;
  }

  interface TransformedData {
    value: string;
    label: string;
  }

  function transformData(data: ApiData[]): TransformedData[] {
    return data.map((item) => ({
      value: item.uuid,
      label: item.ident,
    }));
  }

  const fetchOptions = () => {
    setTimeout(() => {
      fetch(API_URL + "/wholesaler/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          return response.json();
        })
        .then(
          (result) => {
            if (result.status.success) {
              setWholesalerList(transformData(result.data));
            } else {
              console.warn("List of wholesalers not found");
            }
          },
          (error) => {
            console.warn("List of wholesalers not found");
          }
        );
    }, 100);
  };

  const selectInputRef = useRef<any>(null);

  const loadOptionsBranchStatic = (uuid: any) => {
    fetch(API_URL + "/wholesaler/branch/list ", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ wholesaler: { uuid: uuid } }),
    })
      .then((response) => {
        return response.json();
      })
      .then(
        (result) => {
          if (result.status.success) {
            const transformedData = result.data.map((item: any) => ({
              value: item.uuid,
              label: item.ident,
            }));
            setShowBranchSelect(true);
            setBranchsList(transformedData);
          } else {
            console.warn("List of wholesalers not found");
          }
        },
        (error) => {
          console.warn("List of wholesalers not found");
        }
      );
  };

  const customStyles = {
    menuList: (provided: any) => ({
      ...provided,
      maxHeight: '180px', // set your desired max height here
    }),
  };

  return (
    <div className="page UpdateWholesaleForm">
      <Content>
        <h2>
          Wybierz swoją <br /> hurtownię i oddział
        </h2>
        <p className="disclamer">
          Abyś mógł swobodnie korzystać z serwisu, prosimy <br /> o wybór
          hurtowni i oddziału, z którymi współpracujesz.{" "}
        </p>
        <div className="wrapper">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="input-item">
              <label htmlFor="wholesale">Nazwa hurtowni</label>
              <Controller
                name="wholesale"
                control={control}
                rules={{ required: "Nazwa hurtowni is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    // cacheOptions
                    // defaultOptions
                    // loadOptions={loadOptions},
                    options={wholesalerList}
                    placeholder="Podaj nazwę hurtowni"
                    noOptionsMessage={() => "Brak hurtowni o podanej nazwie"}
                    className={
                      errors.wholesale
                        ? "error-input businessName"
                        : "businessName"
                    }
                    styles={customStyles}
                    onChange={(event: any) => {
                      field.onChange(event);
                      loadOptionsBranchStatic(event.value);
                    }}
                    onFocus={() => onClear()}
                  />
                )}
              />
              {errors.wholesale && <p className="error">Pole wymagane</p>}
            </div>
            <div className="input-item">
              <label htmlFor="branchName">Nazwa oddziału</label>
              <Controller
                name="branchName"
                control={control}
                rules={{ required: "Nazwa oddziału jest wymagana" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={branchsList}
                    ref={selectInputRef}
                    isDisabled={!showBranchSelect}
                    styles={customStyles}
                    className={
                      errors.branchName
                        ? "error-input businessName"
                        : "businessName"
                    }
                    placeholder="Podaj nazwę oddziału"
                    noOptionsMessage={() => "Brak oddziału o podanej nazwie"}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                    }}
                  />
                )}
              />
              {errors?.branchName && <p className="error">Pole wymagane</p>}
            </div>
            <p className="disclamer">
              Pamiętaj, że po zapisaniu wyboru nie będzie możliwości zmiany,
              więc upewnij się, że wybrałeś odpowiednią opcję.
            </p>
            <Button type="submit" onClick={handleSubmit(onSubmit)}>
              Wybierz
            </Button>
          </form>
        </div>
      </Content>
    </div>
  );
}

export default UpdateWholesaleForm;
